import React, { useEffect } from "react";
import Routing from "./Navigation";
import ScrollToTop from "./Views/Components/ScrollToTop";
import ApiLoader from "./Views/Components/Widget/ApiLoader";
import { useDispatch } from "react-redux";
import { removeAuth } from "./Reducers/Authentication";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let logoutTimer;

    const logoutUser = () => {
      console.log("Logging out due to inactivity");
      dispatch(removeAuth());
      window.location.href = "/login";
    };

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(logoutUser, 15 * 60 * 1000); // 15 minutes
    };

    const activityEvents = ["mousemove", "keydown", "click", "scroll"];
    const handleActivity = () => {
      resetTimer();
    };

    activityEvents.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    resetTimer(); // Start timer initially

    return () => {
      clearTimeout(logoutTimer);
      activityEvents.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [dispatch]);

  return (
    <>
      <ApiLoader />
      <ScrollToTop />
      <Routing />
    </>
  );
};

export default App;
